//extracted by mini-css-extract-plugin
export default {"shift":"Day_shift__wzfx5","title":"Day_title__7dr1r","checkBox1":"Day_checkBox1__jJ7JI"};;